import { type Type, Directive, output, forwardRef, type OutputEmitterRef } from '@angular/core';
import { DROPDOWN_ITEM_CLICKABLE, type DropdownItemClickHandler } from './dropdown.domain';
import type { DropdownItemComponent } from './dropdown-item.component';

@Directive({
  selector: '[tdWbDropdownItemClick]',
  providers: [{
    provide: DROPDOWN_ITEM_CLICKABLE,
    useExisting: forwardRef((): Type<DropdownItemClickDirective<unknown>> => DropdownItemClickDirective)
  }]
})
export class DropdownItemClickDirective<T> implements DropdownItemClickHandler<T> {
  readonly customClick: OutputEmitterRef<DropdownItemComponent<T>> = output<DropdownItemComponent<T>>();

  onClick(item: DropdownItemComponent<T>): void {
    this.customClick.emit(item);
  }
}
